import styled from 'styled-components';
import { rem } from '../../utils/functions.js';

var getBorderColor = function getBorderColor(_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return error ? theme.colorPalette.utilityColors.error : theme.colorPalette.neutralColors.dark.shade_light_3;
};

var getCheckedBorderColor = function getCheckedBorderColor(_ref2) {
  var error = _ref2.error,
      theme = _ref2.theme;
  return error ? theme.colorPalette.utilityColors.error : theme.colorPalette.primaryColors.main.shade_default;
};

var CheckboxWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__CheckboxWrapper",
  componentId: "qwzu5h-0"
})(["display:inline-block;position:relative;height:28px;width:28px;margin:3px 10px 3px 3px;", ""], function (_ref3) {
  var checkboxStyle = _ref3.checkboxStyle;
  return checkboxStyle;
});
process.env.NODE_ENV !== "production" ? CheckboxWrapper.displayName = 'CheckboxWrapper' : void 0;
var CheckboxInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "styledComponents__CheckboxInput",
  componentId: "qwzu5h-1"
})(["appearance:none;-ms-progress-appearance:none;background:", ";border-style:solid;border-width:1px;border-color:", ";width:28px;height:28px;vertical-align:bottom;margin:0;cursor:pointer;&::-ms-check{color:transparent;border-style:solid;border-width:1px;border-color:", ";background:", ";}:hover,:focus{border-width:2px;&::-ms-check{border-width:2px;}}&:checked{border-width:2px;border-color:", ";&::-ms-check{border-width:2px;border-color:", ";}& + .checkbox-icon{display:block;}}:disabled,:disabled:hover,:disabled:focus{cursor:not-allowed;border-width:1px;border-color:", ";&::-ms-check{border-width:1px;border-color:", ";}&:checked{border-width:2px;&::-ms-check{border-width:2px;}}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, getBorderColor, getBorderColor, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, getCheckedBorderColor, getCheckedBorderColor, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
});
process.env.NODE_ENV !== "production" ? CheckboxInput.displayName = 'CheckboxInput' : void 0;
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "qwzu5h-2"
})(["position:absolute;top:0;left:0;width:", ";height:", ";line-height:", ";text-align:center;pointer-events:none;display:none;"], rem(28), rem(28), rem(28));
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : void 0;

export { CheckboxInput, CheckboxWrapper, IconWrapper };
